"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    AvatarContextProvider: ()=>AvatarContextProvider,
    useAvatarContext: ()=>useAvatarContext
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const avatarContext = /*#__PURE__*/ _react.createContext(undefined);
const avatarContextDefaultValue = {};
const AvatarContextProvider = avatarContext.Provider;
var _React_useContext;
const useAvatarContext = ()=>(_React_useContext = _react.useContext(avatarContext)) !== null && _React_useContext !== void 0 ? _React_useContext : avatarContextDefaultValue; //# sourceMappingURL=AvatarContext.js.map

//# sourceMappingURL=AvatarContext.js.map